import React from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import { DrawerHeader, IconButtonMenuClosed, IconButtonMenuOpen } from './StyledComponentsMenu';

export const DrawerHeaderComponent = ({ open, handleDrawerClose, handleDrawerOpen }) => {
  return (
    <DrawerHeader open={open}>
      {open ? (
        <IconButtonMenuOpen onClick={handleDrawerClose} disableRipple={true}>
          <MenuOpenIcon sx={{ width: '42px', height: '42px' }} />
        </IconButtonMenuOpen>
      ) : (
        <IconButtonMenuClosed onClick={handleDrawerOpen} disableRipple={true}>
          <MenuIcon sx={{ width: '42px', height: '42px' }} />
        </IconButtonMenuClosed>
      )}
    </DrawerHeader>
  );
};
